<template>
  <div class="coupon-list-wrap">
    <template-search-list :listApi="listApi"
                          :buttonOption="buttonOption"
                          :defaultSortBy="defaultSortBy"
                          :reload="reload"
                          :selected="selected"
                          @select="setSelected"
                          @showDetail="showDetail">
      <ui-button :color="'green'"
                 @click="toggleInsert">
        <i class="xi-plus"></i> 쿠폰 생성
      </ui-button>
    </template-search-list>

    <template-insert :show="show.insert"
                     :metaApi="insertMetaApi"
                     :insertApi="insertApi"
                     @reload="reloadList"
                     @saved="showDetail"
                     @close="toggleInsert">
      <h4 class="title"><i class="bi-beus"></i> 쿠폰 생성</h4>
    </template-insert>

    <template-detail :infoApi="infoApi"
                     :editApi="editApi"
                     :removeApi="removeApi"
                     :apiParam="apiParam"
                     @reload="reloadList"
                     @close="setSelected">
    </template-detail>
  </div>
</template>

<script>
import { getBeusCouponList, getBeusCouponInfo, updateBeusCoupon, insertBeusCoupon, getBeusCouponInsertMeta, removeBeusCoupon } from '@/api/marketing'

import TemplateSearchList from '@/components/_template/SearchList'
import TemplateInsert from '@/components/_template/Insert'
import TemplateDetail from '@/components/_template/Detail'
import UiButton from '@/components/_ui/UiButton'

export default {
  name: 'BeusCouponList',
  components: {
    TemplateSearchList,
    TemplateInsert,
    TemplateDetail,
    UiButton
  },
  methods: {
    showDetail (data) {
      this.apiParam = { id: data.id || data.groupId }
    },
    reloadList () {
      this.reload++
    },
    toggleInsert (value = null) {
      this.apiParam = null
      if (value !== null) {
        this.show.insert = !this.show.insert
      } else {
        this.show.insert = value
      }
    },
    setSelected (row) {
      this.selected = row
    },
  },
  data () {
    return {
      reload: 0,
      selected: null,

      infoApi: getBeusCouponInfo,
      editApi: updateBeusCoupon,
      removeApi: removeBeusCoupon,
      insertApi: insertBeusCoupon,
      insertMetaApi: getBeusCouponInsertMeta,
      apiParam: null,

      listApi: getBeusCouponList,
      buttonOption: [
        {
          action: 'showDetail',
          columnText: '자세히',
          buttonText: '<i class="xi-arrow-right"></i>'
        }
      ],
      defaultSortBy: '-createDate',

      show: {
        insert: false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-list-wrap {
}
</style>
